import React, { useState } from "react"
import { Box, Paper, Tab, Tabs, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import Cabecalho from "../Cabecalho"
import { FormClube } from "./components/FormClube"
import { TabelaAssinantes } from "./components/TabelaAssinantes"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: { paddingLeft: "20px", paddingRight: "20px", paddingTop: "80px" },
        [theme.breakpoints.down("sm")]: { paddingLeft: "15px", paddingRight: "15px", paddingTop: "70px" },
    },
    content: {
        margin: "auto",
        maxWidth: "900px",
        [theme.breakpoints.down("sm")]: { maxWidth: "100%" },
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: { fontSize: "1.5rem" },
        [theme.breakpoints.down("xs")]: { fontSize: "1.25rem" },
    },
    subtitle: {
        color: "#7f8c8d",
        marginBottom: theme.spacing(2),
    },
    abas: {
        borderRadius: 20,
        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
        marginBottom: theme.spacing(3),
        overflow: "hidden",
        [theme.breakpoints.down("sm")]: { borderRadius: 15, marginBottom: theme.spacing(2) },
    },
}))

export function ClubeBeneficios() {
    const classes = useStyles()
    const [aba, setAba] = useState(0)

    return (
        <>
            <Cabecalho pagina="Clube de Benefícios" />
            <Box className={classes.container}>
                <Box className={classes.content}>
                    <Typography variant="h5" className={classes.titleText} gutterBottom>
                        Clube de Benefícios
                    </Typography>
                    <Typography variant="body2" className={classes.subtitle}>
                        Venda uma assinatura mensal no cartão de crédito: o cliente paga todo mês e
                        recebe cupons de desconto para usar no seu cardápio digital.
                    </Typography>

                    <Paper className={classes.abas}>
                        <Tabs
                            value={aba}
                            onChange={(_, v: number) => setAba(v)}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                        >
                            <Tab label="Configuração" />
                            <Tab label="Assinantes" />
                        </Tabs>
                    </Paper>

                    {aba === 0 ? <FormClube /> : <TabelaAssinantes />}
                </Box>
            </Box>
        </>
    )
}
